import { useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { StoreState } from '../../types/state';
// import  from '../Common/';
import AddClient from './AddClient';
// import ClientContainer from './ClientContainer';
import ClientDetails from './ClientDetails';
import EditClient from './EditClient';
import ClientList from './ClientList';
import AddUser from './Users/AddUser';
import { Dimmer, Loader } from 'semantic-ui-react';
import ErrorBoundary from '../Common/ErrorBoundary';
import EditSetting from './EditSetting';
import EditPropertySetting from './EditPropertySetting';

const ClientRoutes = () => {
  const { editClient, isLoading, editSetting, editPropertySetting } =
    useSelector((state: StoreState) => ({
      editClient: state.clients.editClient,
      editSetting: state.clients.editSetting,
      editPropertySetting: state.clients.editPropertySetting,
      isLoading: state.tasks.isLoading,
    }));

  return (
    <>
      {isLoading ? (
        <Dimmer page>
          <Loader />
        </Dimmer>
      ) : null}
      {editClient && <EditClient />}
      {editSetting && <EditSetting />}
      {editPropertySetting && <EditPropertySetting />}
      <ErrorBoundary>
        <Switch>
          <Route path={`/clients/view`} exact component={ClientList} />
          <Route path={`/clients/view/:id`} exact component={ClientDetails} />
          <Route path={`/clients/add`} exact component={AddClient} />
          <Route path="/clients" exact component={ClientList} />
          <Route path="/clients/users/add/:id" exact component={AddUser} />
        </Switch>
      </ErrorBoundary>
    </>
  );
};

export default ClientRoutes;
